/* ============================================================
   IZVOR — STINKY cart drawer SKIN (v7)
   Re-brands the Elevate cart drawer, hides leftover content, and
   injects: animated milestone ladder, upsell card (visible title),
   ОТСТЪПКА/ОБЩО totals, payment icons, fixed button/heading, and
   opens the drawer from the header cart icon (instead of /cart).
   Works WITHOUT the locked config/settings_data.json.
   Loaded from theme.liquid. Removable: delete this file + its <script>.
   ============================================================ */
(function () {
  'use strict';

  // ---- editable milestone ladder (amounts in store currency, EUR) ----
  var GOALS = [
    { amount: 40, label: 'Доставка',      text: 'безплатна доставка', icon: 'M3 5h11v9H3zM14 8h4l3 3v3h-7zM7 18a2 2 0 11-4 0 2 2 0 014 0zM20 18a2 2 0 11-4 0 2 2 0 014 0z' },
    { amount: 60, label: 'Подарък',       text: 'безплатен подарък',   icon: 'M20 12v9H4v-9M2 7h20v5H2zM12 22V7M12 7S9 7 8 5.5 9 3 12 7zM12 7s3 0 4-1.5S15 3 12 7z' },
    { amount: 90, label: 'Голям подарък', text: 'голям подарък',       icon: 'M20 12v9H4v-9M2 7h20v5H2zM12 22V7M12 7S9 7 8 5.5 9 3 12 7zM12 7s3 0 4-1.5S15 3 12 7z' }
  ];
  var UPSELL_HANDLE = 'izvor-naturalen-dezodorant-24h';
  var CHECKOUT_TEXT = 'Преминаване към плащане';

  var CSS = [
    '#shopify-section-cart-drawer .drawer__inner,',
    '#shopify-section-cart-drawer .drawer__header,',
    '#shopify-section-cart-drawer .drawer__body,',
    '#shopify-section-cart-drawer .drawer__footer{background:#FBF9F2 !important;}',
    '#shopify-section-cart-drawer .drawer__heading{color:#1B2B22 !important;font-weight:800;text-transform:none !important;}',
    '#shopify-section-cart-drawer .social-proof-bar{display:none !important;}',
    '#shopify-section-cart-drawer .cart-upsell-empty-state{display:none !important;}',
    '#shopify-section-cart-drawer .cart__checkout-button,',
    '#shopify-section-cart-drawer button.cart__checkout-button{',
    '  background:linear-gradient(180deg,#CD6F3B 0%,#C2632F 60%,#B5571F 100%) !important;',
    '  color:#FFF8EE !important;border:none !important;border-radius:999px !important;font-weight:800 !important;}',
    '#shopify-section-cart-drawer .cart-item__savings-badge{background:#C2632F !important;border-color:#C2632F !important;color:#FFF8EE !important;}',
    /* ladder */
    '.izvl{font-family:"Sofia Sans",-apple-system,BlinkMacSystemFont,sans-serif;padding:16px 16px 10px;color:#1B2B22;}',
    '.izvl__msg{font-size:16px;font-weight:700;text-align:center;margin:0 0 14px;line-height:1.35;}',
    '.izvl__msg b{color:#C2632F;}',
    '.izvl__row{position:relative;height:64px;}',
    '.izvl__track{position:absolute;top:12px;left:2px;right:2px;height:9px;border-radius:999px;background:#E4D8C5;overflow:hidden;}',
    '.izvl__fill{position:absolute;top:0;left:0;bottom:0;border-radius:999px;background:linear-gradient(90deg,#C9A86A,#2E5941);transform-origin:left center;}',
    '.izvl__fill::before{content:"";position:absolute;inset:0;background-image:linear-gradient(45deg,rgba(255,255,255,.22) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.22) 50%,rgba(255,255,255,.22) 75%,transparent 75%,transparent);background-size:22px 22px;animation:izvlStripes .8s linear infinite;}',
    '@keyframes izvlStripes{from{background-position:0 0}to{background-position:22px 0}}',
    '.izvl--grow .izvl__fill{animation:izvlGrow .65s cubic-bezier(.4,0,.2,1) both;}',
    '@keyframes izvlGrow{from{transform:scaleX(0)}to{transform:scaleX(1)}}',
    '.izvl__badge{position:absolute;top:16.5px;transform:translate(-50%,-50%);width:30px;height:30px;border-radius:50%;background:#2E5941;border:3px solid #FBF9F2;display:flex;align-items:center;justify-content:center;color:#fff;box-shadow:0 3px 10px rgba(46,89,65,.4);z-index:3;}',
    '.izvl--grow .izvl__badge{animation:izvlBadge .6s cubic-bezier(.22,1,.36,1) both;}',
    '@keyframes izvlBadge{from{opacity:0;transform:translate(-50%,-50%) scale(.3)}to{opacity:1;transform:translate(-50%,-50%) scale(1)}}',
    '.izvl__badge svg{width:15px;height:15px;}',
    '.izvl__pt{position:absolute;top:16.5px;transform:translate(-50%,-50%);width:32px;height:32px;border-radius:50%;background:#fff;border:1.5px solid #E4D8C5;display:flex;align-items:center;justify-content:center;color:#A9B5A4;transition:.3s;}',
    '.izvl__pt svg{width:18px;height:18px;}',
    '.izvl__pt.is-on{border-color:#2E5941;color:#fff;background:#2E5941;box-shadow:0 4px 12px rgba(46,89,65,.3);}',
    '.izvl__lbl{position:absolute;top:38px;transform:translateX(-50%);width:84px;font-size:10px;font-weight:700;text-transform:uppercase;color:#6F7B6F;text-align:center;line-height:1.2;}',
    '.izvl__lbl.is-on{color:#2E5941;}',
    /* upsell */
    '.izvu-wrap{margin:10px 16px 14px;}',
    '.izvu-h{font-size:11.5px;font-weight:800;letter-spacing:.1em;text-transform:uppercase;color:#C2632F;margin:0 0 8px;}',
    '.izvu{border:1px solid #E4D8C5;border-radius:16px;background:#FFFCF6;padding:12px;display:flex;align-items:center;gap:12px;font-family:"Sofia Sans",sans-serif;}',
    '.izvu__img{width:54px;height:54px;border-radius:12px;object-fit:cover;flex:0 0 auto;border:1px solid #E4D8C5;background:#F4EFE6;}',
    '.izvu__info{flex:1;min-width:0;}',
    '.izvu__t{font-size:13.5px;font-weight:800;color:#1B2B22;line-height:1.25;margin:0 0 3px;}',
    '.izvu__sub{font-size:12.5px;color:#5A6B5D;font-weight:600;}',
    '.izvu__btn{flex:0 0 auto;border:none;cursor:pointer;border-radius:999px;padding:10px 16px;font-weight:800;font-size:13px;color:#FFF8EE;font-family:inherit;background:linear-gradient(180deg,#CD6F3B 0%,#C2632F 60%,#B5571F 100%);box-shadow:0 6px 16px rgba(194,99,47,.3);transition:transform .15s,filter .2s;white-space:nowrap;}',
    '.izvu__btn:hover{transform:translateY(-1px);filter:brightness(1.05);}',
    '.izvu__btn[disabled]{opacity:.6;cursor:default;transform:none;}',
    /* totals */
    '.izvt{font-family:"Sofia Sans",sans-serif;padding:6px 16px 4px;}',
    '.izvt__row{display:flex;justify-content:space-between;align-items:baseline;font-size:14px;margin:2px 0;}',
    '.izvt__row--disc{color:#2E5941;font-weight:700;}',
    '.izvt__row--total{font-size:18px;font-weight:900;color:#1B2B22;margin-top:4px;}',
    /* payment icons */
    '.izvpay{display:flex;flex-wrap:wrap;gap:6px;justify-content:center;padding:10px 16px 16px;}',
    '.izvpay__c{height:24px;min-width:40px;padding:0 8px;border:1px solid #E4D8C5;border-radius:5px;background:#fff;display:inline-flex;align-items:center;justify-content:center;font-family:Arial,Helvetica,sans-serif;font-size:10px;font-weight:800;letter-spacing:.03em;}',
    '.izvpay__visa{color:#1A1F71;}.izvpay__amex{color:#1F72CD;}.izvpay__pp{color:#003087;}.izvpay__ap{color:#000;}.izvpay__gp{color:#3C4043;}',
    '.izvpay__mc span{width:13px;height:13px;border-radius:50%;display:block;}',
    '.izvpay__mc span:first-child{background:#EB001B;}',
    '.izvpay__mc span:last-child{background:#F79E1B;margin-left:-5px;mix-blend-mode:multiply;}'
  ].join('\n');

  function injectCSS(){ if(document.getElementById('izvl-css'))return; var s=document.createElement('style'); s.id='izvl-css'; s.textContent=CSS; document.head.appendChild(s); }
  function money(eur){ var v=(Math.round(eur*100)/100).toFixed(2).replace('.',','); return v.replace(/,00$/,'')+' €'; }
  function iconSvg(d){ return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="'+d+'"/></svg>'; }
  function sec(){ return document.getElementById('shopify-section-cart-drawer'); }
  function items(s){ return s.querySelector('.cart-items'); }
  function content(s){ return s.querySelector('.drawer__cart-items-wrapper')||s.querySelector('.drawer__contents')||s.querySelector('.cart__contents'); }
  function esc(t){ return String(t==null?'':t).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }

  // ---------- ladder (striped fill; width set directly in HTML; CSS-class grow on amount change) ----------
  var lastSub=-1;
  function renderLadder(s, subtotal){
    var anchor=items(s), host=content(s); if(!anchor&&!host)return;
    var N=GOALS.length, pos=GOALS.map(function(g,i){ return ((i+0.5)/N)*100; });
    var last=GOALS[N-1].amount, fill;
    if(subtotal<=0) fill=0;
    else if(subtotal>=last) fill=100;
    else { var pa=0,pp=0; for(var i=0;i<N;i++){ var a=GOALS[i].amount,p=pos[i]; if(subtotal<a){ fill=pp+(subtotal-pa)/(a-pa)*(p-pp); break; } pa=a; pp=p; } if(fill===undefined)fill=100; }
    var next=null; for(var j=0;j<N;j++){ if(subtotal<GOALS[j].amount){ next=GOALS[j]; break; } }
    var bIcon=next?next.icon:GOALS[N-1].icon;
    var msg=next?('Още <b>'+money(next.amount-subtotal)+'</b> до '+next.text+' 🎁'):'Честито! Отключи всички промоции! 🎉';

    var existing=s.querySelector('.izvl');
    var changed=(subtotal!==lastSub);
    if(existing && !changed) return;            // already shown for this amount → keep (no flicker)
    if(existing) existing.remove();
    lastSub=subtotal;

    var pts='',lbls='';
    GOALS.forEach(function(g,idx){ var on=subtotal>=g.amount;
      pts+='<div class="izvl__pt'+(on?' is-on':'')+'" style="left:'+pos[idx]+'%">'+iconSvg(g.icon)+'</div>';
      lbls+='<div class="izvl__lbl'+(on?' is-on':'')+'" style="left:'+pos[idx]+'%">'+g.label+'</div>'; });
    var grow=changed?' izvl--grow':'';          // animate the fill only when the amount changed
    var html='<div class="izvl'+grow+'"><p class="izvl__msg">'+msg+'</p><div class="izvl__row"><div class="izvl__track"><div class="izvl__fill" style="width:'+fill+'%"></div></div><div class="izvl__badge" style="left:'+fill+'%">'+iconSvg(bIcon)+'</div>'+pts+lbls+'</div></div>';
    if(anchor) anchor.insertAdjacentHTML('beforebegin',html); else host.insertAdjacentHTML('afterbegin',html);
  }

  // ---------- totals ----------
  function renderTotals(s, cart){
    var footer=s.querySelector('.drawer__footer')||s.querySelector('.cart__ctas'); if(!footer)return;
    var anchor=footer.querySelector('.cart__ctas')||footer;
    var disc=(cart.total_discount||0)/100, total=(cart.total_price||0)/100;
    var html='<div class="izvt">'+(disc>0?'<div class="izvt__row izvt__row--disc"><span>Отстъпка</span><span>− '+money(disc)+'</span></div>':'')+'<div class="izvt__row izvt__row--total"><span>Общо</span><span>'+money(total)+'</span></div></div>';
    var ex=s.querySelector('.izvt'); if(ex){ ex.outerHTML=html; } else { anchor.insertAdjacentHTML('beforebegin',html); }
  }

  // ---------- upsell (visible product title + scent + price) ----------
  var product=null;
  function loadProduct(){ if(product)return Promise.resolve(product); return fetch('/products/'+UPSELL_HANDLE+'.js').then(function(r){return r.json();}).then(function(p){product=p;return p;}).catch(function(){return null;}); }
  function renderUpsell(s, cart){
    if(!product||!cart||cart.item_count===0){ var e=s.querySelector('.izvu-wrap'); if(e)e.remove(); return; }
    var v=(product.variants||[]).filter(function(x){return x.available;})[0]||product.variants[0]; if(!v)return;
    var img=(v.featured_image&&v.featured_image.src)||product.featured_image||(product.images&&product.images[0])||'';
    if(img.indexOf('//')===0) img='https:'+img; else if(img.indexOf('/')===0) img=location.origin+img;
    var imgsrc=img?(img+(img.indexOf('?')>-1?'&':'?')+'width=120'):'';
    var imgtag=imgsrc?'<img class="izvu__img" src="'+imgsrc+'" alt="" loading="lazy" onerror="this.style.display=\'none\'">':'';
    var scent=(v.title&&v.title!=='Default Title')?esc(v.title)+' · ':'';
    var html='<div class="izvu-wrap"><p class="izvu-h">Допълни рутината си</p><div class="izvu">'+imgtag+'<div class="izvu__info"><p class="izvu__t">'+esc(product.title)+'</p><span class="izvu__sub">'+scent+money((v.price||0)/100)+'</span></div><button class="izvu__btn" data-izvu-add="'+v.id+'">+ Добави</button></div></div>';
    var anchor=items(s), host=content(s); if(!anchor&&!host)return;
    var ex=s.querySelector('.izvu-wrap'); if(ex){ ex.outerHTML=html; return; }
    if(anchor) anchor.insertAdjacentHTML('afterend',html); else host.insertAdjacentHTML('beforeend',html);
  }

  // ---------- payment icons (under the checkout button) ----------
  var PAY='<div class="izvpay">'+
    '<span class="izvpay__c izvpay__visa">VISA</span>'+
    '<span class="izvpay__c izvpay__mc"><span></span><span></span></span>'+
    '<span class="izvpay__c izvpay__amex">AMEX</span>'+
    '<span class="izvpay__c izvpay__pp">PayPal</span>'+
    '<span class="izvpay__c izvpay__ap">Apple Pay</span>'+
    '<span class="izvpay__c izvpay__gp">G Pay</span>'+
  '</div>';
  function renderPay(s){ var footer=s.querySelector('.drawer__footer'); if(!footer||s.querySelector('.izvpay'))return; footer.insertAdjacentHTML('beforeend',PAY); }

  // ---------- chrome + badge typo ----------
  function fixChrome(s, cart){
    var btn=s.querySelector('.cart__checkout-button');
    if(btn){ var w=document.createTreeWalker(btn,NodeFilter.SHOW_TEXT,null),n; while(n=w.nextNode()){ if(/[А-Яа-я]/.test(n.nodeValue)){ if(n.nodeValue.indexOf(CHECKOUT_TEXT)===-1) n.nodeValue=CHECKOUT_TEXT+' '; break; } } }
    var h=s.querySelector('.drawer__heading');
    if(h && cart){ var n2=cart.item_count===1?'продукт':'продукта'; h.textContent='Количка • '+cart.item_count+' '+n2; }
  }
  function fixBadges(s){ s.querySelectorAll('.cart-item__savings-badge').forEach(function(b){ if(b.innerHTML.indexOf('Спрестяваш')>-1) b.innerHTML=b.innerHTML.replace(/Спрестяваш/g,'Спестяваш'); }); }

  function render(cart){
    injectCSS(); var s=sec(); if(!s)return;
    renderLadder(s,(cart.items_subtotal_price||0)/100);
    renderTotals(s,cart);
    renderUpsell(s,cart);
    renderPay(s);
    fixChrome(s,cart);
    fixBadges(s);
  }
  function refresh(){ fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();}).then(render).catch(function(){}); }

  // add-from-upsell: add + re-render native drawer section, then overlays
  document.addEventListener('click', function(e){
    var b=e.target.closest('[data-izvu-add]'); if(!b)return; e.preventDefault();
    if(b.disabled)return; b.disabled=true; b.textContent='…';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
      body:JSON.stringify({items:[{id:parseInt(b.getAttribute('data-izvu-add'),10),quantity:1}],sections:'cart-drawer',sections_url:location.pathname})})
      .then(function(r){return r.json();})
      .then(function(d){
        if(d && d.sections && d.sections['cart-drawer']){
          var cur=document.getElementById('shopify-section-cart-drawer');
          var doc=new DOMParser().parseFromString(d.sections['cart-drawer'],'text/html');
          var inc=doc.querySelector('#shopify-section-cart-drawer');
          if(cur && inc) cur.innerHTML=inc.innerHTML;
        }
        try{ document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true})); }catch(e){}
        refresh();
      }).catch(function(){ b.disabled=false; b.textContent='+ Добави'; });
  });

  // open the drawer from the header cart icon instead of navigating to /cart
  document.addEventListener('click', function(e){
    var a=e.target.closest('a.izvh-cart, #cart-icon-bubble, a[href="/cart"], a[href$="/cart"]');
    if(!a) return;
    if(a.closest('#shopify-section-cart-drawer')) return;
    var cd=document.querySelector('cart-drawer');
    if(cd && typeof cd.open==='function'){ e.preventDefault(); cd.open(a); setTimeout(refresh,50); }
  }, true);

  function boot(){
    loadProduct().then(refresh);
    var s=sec(); if(!s)return; var t;
    new MutationObserver(function(){ if(s.querySelector('.izvl')&&s.querySelector('.izvt'))return; clearTimeout(t); t=setTimeout(refresh,60); }).observe(s,{childList:true,subtree:true});
    document.addEventListener('cart:refresh',refresh);
    try{ if(window.PUB_SUB_EVENTS&&window.PUB_SUB_EVENTS.cartUpdate&&window.subscribe){ window.subscribe(window.PUB_SUB_EVENTS.cartUpdate,refresh); } }catch(e){}
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot); else boot();
})();
